function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Description_list",
  "data-name": "Description list"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0H18V18H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M12.825,13.5H.675A.721.721,0,0,1,0,12.825V.675A.676.676,0,0,1,.675,0h12.15A.721.721,0,0,1,13.5.675v12.15A.8.8,0,0,1,12.825,13.5ZM1.5,1.5V12H12V1.5Zm9,9H6V9h4.5v1.5Zm-6,0H3V9H4.5v1.5Zm6-3H6V6h4.5V7.5Zm-6,0H3V6H4.5V7.5Zm6-3H6V3h4.5V4.5Zm-6,0H3V3H4.5V4.5Z",
  transform: "translate(2.25 2.25)"
}));

var SvgIconList = function SvgIconList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Description_list",
    "data-name": "Icon Description list",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-list.b55f59b4.svg";
export { ForwardRef as ReactComponent };